import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { STATUS_ROLES } from './constants';

export const optionClasses = selected =>
  classNames('dropdown-option', { selected });

function AutosuggestOption({
  highlightedIndex,
  selectedItem,
  index,
  item,
  getItemProps,
  itemToString,
  inputValue,
}) {
  const isHighlighted = index === highlightedIndex;
  const isSelected = selectedItem && item.id === selectedItem.id;
  const itemInfo = {
    item,
    className: classNames(optionClasses(isHighlighted || isSelected)),
    index,
    'aria-selected': item.statusRole
      ? undefined
      : inputValue === itemToString(item),
  };

  const props = getItemProps(itemInfo);

  return (
    <li
      {...props}
      data-testid={`autosuggest-option-${item.id || `${item}-${index}`}`}
    >
      {itemToString(item)}
    </li>
  );
}

AutosuggestOption.propTypes = {
  getItemProps: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    toDisplay: PropTypes.string.isRequired,
    disabled: PropTypes.bool, // optional -- default is false
    // statusRole - only set on non-interactive status/alert rows
    // (e.g. "No matching services found"). Omit on normal options so
    // aria-selected stays in play.
    statusRole: PropTypes.oneOf(STATUS_ROLES),
    // anything else -- not strict
  }).isRequired,
  itemToString: PropTypes.func.isRequired,
  highlightedIndex: PropTypes.number,
  inputValue: PropTypes.string,
  selectedItem: PropTypes.object,
};

export default AutosuggestOption;
